/**
 * Create store system routing-rip
 *
 * @since 2018-07-09
 * @author jongsung.Lee(devp010)
 */

import {SystemApiPrefix as smApiPrefix} from 'utils'
import compareObject from '~/utils/compare'

export const plugins = [Plugin]

export const state = () => ({
  // axios api's urls
  apiUrlPath: {
    // rip config
    ripConfig: `${smApiPrefix}/rip/config`,
    // rip status
    ripStatus: `${smApiPrefix}/rip/config/status`,
    // network list
    ripNetworks: `${smApiPrefix}/rip/config/networks`,
    // rip advance
    ripAdvance: `${smApiPrefix}/rip/config/advance`,
    // rip interface candidates
    ripIfsCandis: `${smApiPrefix}/rip/config/interface-candidates`,
    // rip apply
    ripApply: `${smApiPrefix}/rip/config/apply`,
    // rip cancel
    ripCancel: `${smApiPrefix}/rip/config/cancel`
  },
  // copyData of editing.
  selectedItem: {},
  // rip config
  ripConfig: {
    enable: 0, //      required (one of 0, 1)
    version: 1 //      required (one of 1, 2)
  },
  // clone of ripConfig
  ripConfigClone: {
    enable: 0, //      required (one of 0, 1)
    version: 1 //      required (one of 1, 2)
  },
  // rip status
  ripStatus: {
    status: ''
  },
  ripNetwork: {
    id: 0,
    network_addr: '', //  네트워크 IP 주소
    network_mask: 0 //    네트워크 IP mask
  },
  ripNetworkList: [],
  ripAdvance: {
    metric: 1, //           required (integer - default: 1 - minimum: 1 - maximum: 16) 메트릭
    distance: 120, //       required (integer - default: 120 - minimum: 1 - maximum: 255) Distance
    update_timer: 30, //    required (number - default: 30 - minimum: 5 - maximum: 2147483647) 업데이트
    tm_out_timer: 180, //   required (number - default: 180 - minimum: 5 - maximum: 2147483647) Timeout
    flush_timer: 120, //    required (number - default: 120 - minimum: 5 - maximum: 2147483647) Garbage
    static_enable: 0, //    required (one of 0, 1) 사용(OFF: 0, ON: 1)
    static_metric: 1, //    required (integer - minimum: 1 - maximum: 16) Static
    ospf_enable: 0, //      required (one of 0, 1) 사용(OFF: 0, ON: 1)
    ospf_metric: 1, //      required (integer - minimum: 1 - maximum: 16) OSPF
    bgp_enable: 0, //       required (one of 0, 1)사용(OFF: 0, ON: 1)
    bgp_metric: 1, //       required (integer - minimum: 1 - maximum: 16)BGP
    rout_map_enable: 0, //  required (one of 0, 1) 사용(OFF: 0, ON: 1)
    rout_map_sync_interval: 5, // required (integer - default: 5 - minimum: 1 - maximum: 60) 연동 주기(초)
    rout_map: [] //         required (array of items) : id, rout_addr, rout_mask, metric, ifc_id, ifc_name, order
  },
  rout_mapInfo: {
    id: '',
    rout_addr: null,
    rout_mask: 0,
    metric: 0,
    ifc_id: '',
    ifc_name: '',
    order: 1
  },
  ripIfsCandidateList: []
})

export const mutations = {
  resetSelectedItem (state) {
    state.selectedItem = {}
  },
  setSelectedItem (state, item) {
    state.selectedItem = item
  },
  resetRipConfig (state) {
    state.ripConfig.enable = 0
    state.ripConfig.version = 1
  },
  setRipConfig (state, data) {
    if (data !== undefined) {
      state.ripConfig.enable = data.enable
      state.ripConfig.version = data.version
      // clone
      state.ripConfigClone.enable = _.cloneDeep(data.enable)
      state.ripConfigClone.version = _.cloneDeep(data.version)
    }
  },
  resetRipStatus (state) {
    state.ripStatus.status = ''
  },
  setRipStatus (state, data) {
    if (data !== undefined) {
      state.ripStatus.status = data.status
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip network
  // network dialog
  clearRipNetworkDialog (state) {
    state.ripNetwork.id = 0
    state.ripNetwork.network_addr = null
    state.ripNetwork.network_mask = 0
  },
  setRipNetworkDialog (state, item) {
    state.ripNetwork.id = item.id
    state.ripNetwork.network_addr = item.network_addr
    state.ripNetwork.network_mask = item.network_mask
  },
  resetRipNetworkList (state) {
    state.ripNetworkList = []
  },
  setRipNetworkList (state, data) {
    if (data !== undefined) {
      state.ripNetworkList = data
    }
  },
  addRipNetworkList (state, item) {
    if (item !== undefined) {
      state.ripNetworkList.push(item)
    }
  },
  editRipNetworkList (state, item) {
    const findRslt = _.find(state.ripNetworkList, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.ripNetworkList.splice(_.findIndex(state.ripNetworkList, state.selectedItem), 1, item)
    }
  },
  delRipNetworkList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.ripNetworkList.splice(item.itemIndex, 1)
      }
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip advance
  resetRipAdvanceSetInfo (state) {
    state.ripAdvance.metric = 1
    state.ripAdvance.distance = 120
    state.ripAdvance.update_timer = 30
    state.ripAdvance.tm_out_timer = 180
    state.ripAdvance.flush_timer = 120
    state.ripAdvance.static_enable = 0
    state.ripAdvance.static_metric = 1
    state.ripAdvance.ospf_enable = 0
    state.ripAdvance.ospf_metric = 1
    state.ripAdvance.bgp_enable = 0
    state.ripAdvance.bgp_metric = 1
    state.ripAdvance.rout_map_enable = 0
    state.ripAdvance.rout_map_sync_interval = 5
    state.ripAdvance.rout_map = []
  },
  setRipAdvanceSetInfo (state, data) {
    if (data !== undefined) {
      state.ripAdvance.metric = data.metric
      state.ripAdvance.distance = data.distance
      state.ripAdvance.update_timer = data.update_timer
      state.ripAdvance.tm_out_timer = data.tm_out_timer
      state.ripAdvance.flush_timer = data.flush_timer
      state.ripAdvance.static_enable = data.static_enable
      state.ripAdvance.static_metric = data.static_metric
      state.ripAdvance.ospf_enable = data.ospf_enable
      state.ripAdvance.ospf_metric = data.ospf_metric
      state.ripAdvance.bgp_enable = data.bgp_enable
      state.ripAdvance.bgp_metric = data.bgp_metric
      state.ripAdvance.rout_map_enable = data.rout_map_enable
      state.ripAdvance.rout_map_sync_interval = data.rout_map_sync_interval
      if (data.rout_map !== null && data.rout_map.length > 0) {
        for (const rmap of data.rout_map) {
          rmap.id = `${_.random(100, 10000)}_${rmap.rout_addr}`
        }
        state.ripAdvance.rout_map = data.rout_map
      } else {
        state.ripAdvance.rout_map = []
      }
    }
  },
  moveUpRoutMapByOrder (state, item) {
    // change order the item
    state.ripAdvance.rout_map.splice(item.itemIndex, 1)
    state.ripAdvance.rout_map.splice(item.itemIndex - 1, 0, item)
    let iIdx = 0
    // reset order & itemIndex  properties
    for (const rmap of state.ripAdvance.rout_map) {
      rmap.itemIndex = iIdx++
      rmap.order = iIdx
    }
  },
  moveDownRoutMapByOrder (state, item) {
    // change order the item
    state.ripAdvance.rout_map.splice(item.itemIndex, 1)
    state.ripAdvance.rout_map.splice(item.itemIndex + 1, 0, item)
    let iIdx = 0
    for (const rmap of state.ripAdvance.rout_map) {
      rmap.itemIndex = iIdx++
      rmap.order = iIdx
    }
  },
  editRipAdvanceSetInfo (state, item) {
    if (item !== undefined) {
      state.ripAdvance = item
    }
  },
  resetRipInterfaceCandidates (state) {
    state.ripIfsCandidateList = []
  },
  setRipInterfaceCandidates (state, data) {
    if (data !== undefined && data.length > 0) {
      for (const ifs of data) {
        state.ripIfsCandidateList.push(
          {
            label: ifs.name,
            value: ifs.id
          }
        )
      }
    }
  },
  // routmap dialog
  clearRipRoutMapDialog (state) {
    state.rout_mapInfo.id = ''
    state.rout_mapInfo.rout_addr = null
    state.rout_mapInfo.rout_mask = 0
    state.rout_mapInfo.metric = 0
    state.rout_mapInfo.ifc_id = ''
    state.rout_mapInfo.ifc_name = ''
    state.rout_mapInfo.order = 1
  },
  setRipRoutMapDialog (state, item) {
    state.rout_mapInfo.id = item.id
    state.rout_mapInfo.rout_addr = item.rout_addr
    state.rout_mapInfo.rout_mask = item.rout_mask
    state.rout_mapInfo.metric = item.metric
    state.rout_mapInfo.ifc_id = item.ifc_id
    state.rout_mapInfo.ifc_name = item.ifc_name
    state.rout_mapInfo.order = item.order
  },
  // routmap CRUD
  resetRipRoutMapList (state) {
    state.ripAdvance.rout_map = []
  },
  setRipRoutMapList (state, data) {
    if (data !== undefined && data.length > 0) {
      state.ripAdvance.rout_map = data
    }
  },
  addRipRoutMapList (state, item) {
    state.ripAdvance.rout_map.push(item)
  },
  editRipRoutMapList (state, item) {
    const findRslt = _.find(state.ripAdvance.rout_map, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.ripAdvance.rout_map.splice(_.findIndex(state.ripAdvance.rout_map, state.selectedItem.item), 1, item)
    }
  },
  delRipRoutMapList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.ripAdvance.rout_map.splice(item.itemIndex, 1)
      }
    }
  }
}

export const actions = {
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip config
  async getRipConfig ({commit, state}, loadingOpt) {
    commit('resetRipConfig')
    const apiUrl = state.apiUrlPath['ripConfig']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setRipConfig', result)
      return true
    } else {
      return false
    }
  },
  async editRipConfig ({commit, state}, loadingOpt) {
    const apiUrl = state.apiUrlPath['ripConfig']
    const rslt = await this.$axios.$put(apiUrl, state.ripConfig, loadingOpt)
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('setRipConfig', rslt.result)
      return true
    } else {
      return false
    }
  },
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< rip config
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip status
  async getRipStatus ({commit, state}) {
    commit('resetRipStatus')
    const apiUrl = state.apiUrlPath['ripStatus']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setRipStatus', result)
      return true
    } else {
      return false
    }
  },
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< rip status
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip network
  async getNetworkList ({commit, state}, loadingOpt) {
    commit('resetRipNetworkList')
    const apiUrl = state.apiUrlPath['ripNetworks']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setRipNetworkList', result)
      return true
    } else {
      return false
    }
  },
  // add , // edit , // del(multi)
  async addRipNetworkList ({commit, state}) {
    const apiUrl = state.apiUrlPath['ripNetworks']
    const addParam = {
      network_addr: state.ripNetwork.network_addr,
      network_mask: Number(state.ripNetwork.network_mask)
    }
    const {code, result} = await this.$axios.$post(apiUrl, addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addRipNetworkList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async editRipNetworkList ({commit, state}) {
    const apiUrl = state.apiUrlPath['ripNetworks']
    const putParam = {
      network_addr: state.ripNetwork.network_addr,
      network_mask: Number(state.ripNetwork.network_mask)
    }
    const {code, result} = await this.$axios.$put(`${apiUrl}/${state.ripNetwork.id}`, putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('editRipNetworkList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async delRipNetworkList ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({id: idx.id, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['ripNetworks']
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].id}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delRipNetworkList', param.itemIndexList)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< rip network
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip advacne
  async getRipAdvacne ({commit, state}) {
    commit('resetRipAdvanceSetInfo')
    const rslt = await this.$axios.$get(state.apiUrlPath['ripAdvance'])
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('setRipAdvanceSetInfo', rslt.result)
      return true
    } else {
      return false
    }
  },
  async editRipAdvanceSetInfo ({commit, state}) {
    const putParam = _.cloneDeep(state.ripAdvance)
    if (putParam.rout_map !== undefined && putParam.rout_map.length > 0) {
      let iIdx = 0
      for (const rmap of putParam.rout_map) {
        delete rmap.id
        rmap.itemIndex = iIdx++
        rmap.order = iIdx
      }
    }
    const {code, result} = await this.$axios.$put(state.apiUrlPath['ripAdvance'], putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('editRipAdvanceSetInfo', result)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  // rout_map
  async getRipInterfaceCandidates ({commit, state}) {
    commit('resetRipInterfaceCandidates')
    const {code, result} = await this.$axios.$get(state.apiUrlPath['ripIfsCandis'])
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setRipInterfaceCandidates', result)
      return true
    } else {
      return false
    }
  },
  addRipRoutMapList ({commit, state}) {
    const addParam = _.cloneDeep(state.rout_mapInfo)
    // make id
    addParam.id = `${_.random(100, 10000)}_${state.rout_mapInfo.rout_addr}`
    // rout_mask to number
    addParam.rout_mask = Number(addParam.rout_mask)
    commit('addRipRoutMapList', addParam)
    return true
  },
  editRipRoutMapList ({commit, state}) {
    const putParam = _.cloneDeep(state.rout_mapInfo)
    // rout_mask to number
    putParam.rout_mask = Number(putParam.rout_mask)
    commit('editRipRoutMapList', putParam)
    return true
  },
  delRipRoutMapList ({commit, state}, param) {
    commit('delRipRoutMapList', param.itemIndexList)
    return true
  },
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< rip advance
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> rip apply & cancel
  async setRipApply ({commit, state}, loadingOpt) {
    const data = await this.$axios.$put(state.apiUrlPath['ripApply'], null, loadingOpt)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  },
  async setRipCancel ({commit, state}, loadingOpt) {
    const data = await this.$axios.$put(state.apiUrlPath['ripCancel'], null, loadingOpt)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  }
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< rip apply & cancel
}

export const getters = {
  // rip Config
  compareRipConfigData (state) {
    return compareObject(state.ripConfig, state.ripConfigClone)
  }
}

export const strict = false
